export enum CartMergeMode {
  ALWAYS = "ALWAYS",
  LAST_ONLY = "LAST_ONLY",
  NEVER = "NEVER",
}
